// Client-side username helpers, kept in one place so Signup, ProfileBasics
// and any future edit-profile screen share the exact same rules.

// Xano now accepts more username patterns. Client-side rule:
// - 3–30 chars
// - Only lowercase letters, numbers, periods, underscores
// - Must start and end with a letter or number
// - No consecutive punctuation (safer, matches Xano validation)
export const USERNAME_HINT =
  "3–30 characters. Letters, numbers, periods and underscores. Must start and end with a letter or number.";

export function validateUsername(u) {
  if (!u) return "Username is required.";
  if (u.length < 3) return "Username must be at least 3 characters.";
  if (u.length > 30) return "Username must be at most 30 characters.";
  if (!/^[a-z0-9]/.test(u)) return "Username must start with a letter or number.";
  if (!/[a-z0-9]$/.test(u)) return "Username must end with a letter or number.";
  if (/[^a-z0-9._]/.test(u)) return "Only letters, numbers, periods and underscores are allowed.";
  if (/[._]{2,}/.test(u)) return "Periods and underscores cannot be repeated (e.g. '..' or '__').";
  return "";
}

// Normalise on-input: lowercase, strip disallowed, strip leading punctuation,
// collapse consecutive punctuation. Trailing punctuation is stripped on blur/submit.
export function normalizeUsernameOnInput(raw) {
  let v = (raw || "").toLowerCase().replace(/[^a-z0-9_.]/g, "");
  v = v.replace(/^[._]+/, "");
  v = v.replace(/[._]{2,}/g, (m) => m[0]);
  return v;
}

export function finalCleanUsername(raw) {
  let v = normalizeUsernameOnInput(raw);
  v = v.replace(/[._]+$/, "");
  return v;
}
